import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import walletApi from "./walletApi";

export const getPortfolioWalletList = createThunkFromApi(
  'wallet/getPortfolioWalletList',
  walletApi.getPortfolioWalletList
)

export const getBasketWalletList = createThunkFromApi(
  'wallet/getBasketWalletList',
  walletApi.getBasketWalletList
)

export const getPortfolioBasketMenuViewList = createThunkFromApi(
  'wallet/getPortfolioBasketMenuViewList',
  walletApi.getPortfolioBasketMenuViewList
)

export const getPortfolioWalletInfo = createThunkFromApi(
  'wallet/getPortfolioWalletInfo',
  walletApi.getPortfolioWalletInfo
)

export const getBasketWalletInfo = createThunkFromApi(
  'wallet/getBasketWalletInfo',
  walletApi.getBasketWalletInfo
)

export const getBasketHistoryForm = createThunkFromApi(
  'wallet/getBasketHistoryForm',
  walletApi.getBasketHistoryForm
)

export const getBasketHistoryList = createThunkFromApi(
  'wallet/getBasketHistoryList',
  walletApi.getBasketHistoryList
)

export const getRequestHistoryList = createThunkFromApi(
  'wallet/getRequestHistoryList',
  walletApi.getRequestHistoryList
)

export const getRequestHistoryForm = createThunkFromApi(
  'wallet/getRequestHistoryForm',
  walletApi.getRequestHistoryForm
)

export const getBrokerInfoDetail = createThunkFromApi(
  'wallet/getBrokerInfoDetail',
  walletApi.getBrokerInfoDetail
)

export const getBrokerInfo = createThunkFromApi(
  'wallet/getBrokerInfo',
  walletApi.getBrokerInfo
)

const initialState = {
  portfolioWalletList: null,
  portfolioWalletInfo: null,
  portfolioBasketMenu: null,

  basketHistoryForm: null,
  basketHistoryList: null,

  requestHistoryForm: null,
  requestHistoryList: null,

  brokerInfo: null,
  brokerInfoDetail: null
};

export const walletSlice = createSlice({
  name: "wallet",
  initialState,

  extraReducers: {
    [getBrokerInfo.fulfilled]: (state, { payload }) => {
      state.brokerInfo = payload?.data;
    },

    [getBrokerInfoDetail.fulfilled]: (state, { payload }) => {
      state.brokerInfoDetail = payload?.data;
    },

    [getRequestHistoryList.fulfilled]: (state, { payload }) => {
      state.requestHistoryList = payload?.data;
    },

    [getRequestHistoryForm.fulfilled]: (state, { payload }) => {
      state.requestHistoryForm = payload?.data;
    },

    [getBasketHistoryList.fulfilled]: (state, { payload }) => {
      state.basketHistoryList = payload?.data;
    },

    [getBasketHistoryForm.fulfilled]: (state, { payload }) => {
      state.basketHistoryForm = payload?.data;
    },

    [getPortfolioWalletList.fulfilled]: (state, { payload }) => {
      state.portfolioWalletList = payload?.data;
    },

    [getBasketWalletList.fulfilled]: (state, { payload }) => {
      state.portfolioWalletList = payload?.data;
    },

    [getPortfolioBasketMenuViewList.fulfilled]: (state, { payload }) => {
      state.portfolioBasketMenu = payload?.data;
    },

    [getBasketWalletInfo.fulfilled]: (state, { payload }) => {
      state.portfolioWalletInfo = payload?.data;
    },

    [getPortfolioWalletInfo.fulfilled]: (state, { payload }) => {
      state.portfolioWalletInfo = payload?.data;
    },
  },
});

export default walletSlice.reducer;
